export const formBankValues = (data = {}) => ({
    bank_id: data?.bank_id ?? "",
    branch: data?.branch ?? "",
    account_number: data?.account_number ?? "",
    account_name: data?.account_name ?? "",
  });
  